// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__R5mtv","box":"style_box__D+q3A"};